<template>
  <div
    id="faq"
    class="co-bg-striped"
  >
    <div class="co-container-md mx-auto px-4 py-12 sm:py-[4.25rem]">
      <h2 class="co-heading-2-caption">
        FAQ
      </h2>
      <p class="mb-6 text-center">
        無料相談に関する<a
          href="https://support.techacademy.jp/hc/ja/sections/6357307963405-%E7%84%A1%E6%96%99%E3%83%A1%E3%83%B3%E3%82%BF%E3%83%BC%E7%9B%B8%E8%AB%87%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6?_ga=2.75695190.2101970131.1653889785-537623707.1648532495&amp;_gac=1.153482570.1652404855.Cj0KCQjw4PKTBhD8ARIsAHChzRLy0cDbXCojiPzd_8EWPrOPHyeDzH0setwUr9-yXD-J8H16K5sKK1UaAh1BEALw_wcB"
          target="_blank"
        >よくある質問はこちら</a>よりご確認いただけます。
      </p>
    </div>
  </div>
</template>
